import { useMonitorOutput } from './ce58f0f896f0c6e65f1e848ac7e0f43dbc149e495537060739f1d8bc03ec3f5e.cfe-internal.js';

function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(monitor, collector || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
}

export { useCollectedProps };
